import { useAccount, useBalance, useReadContract } from "wagmi";
import { vaultSwapContractsConfig } from "@config/contractsConfig";

const useVaultSwapTokensBalancesChain = (chainId: number) => {
  const { isConnected, address } = useAccount();
  // const { vaultSwapConfig } = useDappConfig();
  const { agETH = null, wagETH = null } =
    isConnected && chainId && vaultSwapContractsConfig[chainId]?.tokens
      ? vaultSwapContractsConfig[chainId].tokens
      : {};

  const { data: agETHBalance, refetch: refetchAgEthBalance } = useBalance({
    address,
    token: agETH?.address,
    query: {
      enabled: isConnected,
      refetchInterval: 10_000,
    },
    chainId: chainId,
  });

  const { data: agETHAllowance, refetch: refetchAgEthAllowance } =
    useReadContract({
      address: agETH?.address,
      abi: agETH?.abi,
      functionName: "allowance",
      args: [address, wagETH?.address],
      query: {
        enabled: isConnected,
        refetchInterval: 10_000,
      },
      chainId: chainId,
    });

  const { data: wagETHBalance, refetch: refetchWagEthBalance } = useBalance({
    token: wagETH?.address,
    address,
    query: {
      enabled: isConnected,
      refetchInterval: 10_000,
    },
    chainId: chainId,
  });

  const { data: wagETHAllowance, refetch: refetchWagEthAllowance } =
    useReadContract({
      address: wagETH?.address,
      abi: wagETH?.abi,
      functionName: "allowance",
      args: [address, wagETH?.address],
      query: {
        enabled: isConnected,
        refetchInterval: 10_000,
      },
      chainId: chainId,
    });

  const invalidateCache = () => {
    refetchAgEthBalance();
    refetchAgEthAllowance();
    refetchWagEthBalance();
    refetchWagEthAllowance();
  };

  return {
    agETHBalance: agETHBalance?.value || 0n,
    wagETHBalance: wagETHBalance?.value || 0n,
    agETHAllowance: (agETHAllowance as bigint) || 0n,
    wagETHAllowance: (wagETHAllowance as bigint) || 0n,
    invalidateCache,
  };
};

export default useVaultSwapTokensBalancesChain;
